'use strict';

import _ from 'lodash';
import React, {PropTypes} from 'react';
import { connect } from 'react-redux';
import FlatButton from '../../../common/components/c_FlatButton';

@connect((state, props) => {
  const skillCategoryTypes = state.staticData.skillCategoryTypes;
  const skillLevelTypes = state.staticData.skillLevelTypes;
  const skills = state.skills;
  const tempState = state.tempState;

  return  {
    skillCategoryTypes,
    skillLevelTypes,
    skills: _.merge({}, skills, tempState.skills || {}),
    updateTempState: props.updateTempState,
    script: props.script
  };
})
export default class SkillsSummary extends React.Component {
  static propTypes = {
    skills: PropTypes.object,
    skillCategoryTypes: PropTypes.array,
    skillLevelTypes: PropTypes.array,
    updateTempState: PropTypes.func,
    script: PropTypes.bool
  }

  constructor(props) {
    super(props);
  }

  handleRemove(skill) {
    const removedSkill = _.merge({}, this.props.skills[skill.categoryId][skill.name]);
    removedSkill.deleted = Symbol.for('_deleted_');
    this.props.updateTempState('skills', `${removedSkill.categoryId}.${removedSkill.name}`, null, removedSkill);
  }

  render() {

    // Flatten map to array of skills
    const skills = _(this.props.skills)
      .flatMap(category =>
        _.reduce(category, (result, skill) => {

          const cat = _.find(this.props.skillCategoryTypes, {id: skill.categoryId});
          const level = _.find(this.props.skillLevelTypes, {id: skill.skillLevel});
          result.push({...skill, categoryName: (cat || {}).name, skillLevelName: (level || {}).name});
          return result;
        }, [])
      )
      .filter(skill => skill.deleted !== Symbol.for('_deleted_') && skill.name !== 'None') // Do not include those marked for deletion
      .value();

    return (
      <div className='expanded-accordion-content explanation-of-wahve'>
      {
        this.props.script
        &&
          <div className='speaking-callout'>
            Now, let’s review your skills.
          </div>
      }
      <div className='summary-container'>
        <ul>
          <li className='summary-row'>
            <div className='summary-row-item'>Category</div>
            <div className='summary-row-item'>Skill Name</div>
            <div className='summary-row-item'>Last Used</div>
            <div className='summary-row-item'>Yrs of Exp</div>
            <div className='summary-row-item'>Skill Level</div>
          </li>
          {
            _.map(skills, skill =>
              <li className='summary-row'>
                <div className='summary-row-item'>{skill.categoryName}</div>
                <div className='summary-row-item'>{skill.name}</div>
                <div className='summary-row-item'>
                  {
                    (_.isNil(skill.lastUsed)) ? 'N/A' : ((skill.lastUsed === 100) ? 'Current' : (skill.lastUsed === 11) ? `10+ Yr. Ago` : `${skill.lastUsed} Yr. Ago`)
                  }
                </div>
                <div className='summary-row-item'>{(!skill.yearsOfExperience) ? 'N/A' : skill.yearsOfExperience}</div>
                <div className='summary-row-item'>{(!skill.skillLevelName) ? 'N/A' : skill.skillLevelName}</div>
              </li>
            )
          }
          {
            (skills.length === 0)
            &&
            <li className='summary-row'>
              <div className='summary-row-item-empty'>No skills have been selected</div>
            </li>
          }
        </ul>
      </div>
    </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/applicant/SkillsSummary/index.js